export default __webpack_public_path__ + "static/3-97fdf803772da7418182eb96f5e4dcdf.jpg";